<template>
  <div class="sub-result">
    <v-container style="max-width: 560px" class="text-center py-16">
      <div class="result-icon mb-8">
        <l-icon size="52" color="white">mdi-close</l-icon>
      </div>

      <h1 class="text-h3 font-weight-bold mb-4">{{ $t('subResult.cancelTitle') }}</h1>
      <p class="subtitle-1 text--secondary mb-10">{{ $t('subResult.cancelSubtitle') }}</p>

      <v-btn
        color="primary"
        x-large
        height="54"
        depressed
        class="result-btn white--text px-8 mb-4"
        @click="$router.push('/')"
      >
        {{ $t('subResult.tryAgain') }}
      </v-btn>

      <div class="mt-2">
        <span class="text--secondary">{{ $t('pricing.contact') }} </span>
        <a href="mailto:hola@nukliapp.com" class="primary--text text-decoration-none">hola@nukliapp.com</a>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'CancelledSubscription',
  metaInfo() {
    return { title: `${this.$t('subResult.cancelTitle')} | Nukli` };
  },
};
</script>

<style scoped>
/* padding-top: 64px del AppBar fijo + aire (v-main no lo compensa) */
.sub-result { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 96px 16px 32px; }
.result-icon {
  width: 96px;
  height: 96px;
  border-radius: 28px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
  box-shadow: 0 16px 40px rgba(100, 116, 139, 0.25);
}
.text-h3 {
  font-family: 'Space Grotesk', sans-serif !important;
  letter-spacing: -0.02em !important;
}
.subtitle-1 { font-size: 1.2rem !important; line-height: 1.6 !important; }
.result-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 14px !important;
  background: linear-gradient(135deg, #2c7cff 0%, #6366f1 100%) !important;
}
</style>
